let listeners: any[] = []

export type loginStateType = {
  open: boolean
  message?: string
  callback?: () => void
}

let loginState: loginStateType = {
  open: false,
  message: '',
  callback: undefined,
}

const loginStore = {
  setState(newState: typeof loginState) {
    loginState = newState
    listeners.forEach(listener => listener())
  },
  subscribe(listener: () => void) {
    listeners = [...listeners, listener]
    return () => {
      listeners = listeners.filter(l => l !== listener)
    }
  },
  getSnapshot() {
    return loginState
  },
  getServerSnapshot() {
    return loginState
  },
}
export default loginStore
